<template>
  <span class="spinner-border" role="status" aria-hidden="true"></span>
</template>